"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.error.title': 'Activation Failed',
    'activate.error.generic': 'An error occurred during account activation',
    'activate.error.no_token': 'No activation token provided',
    'activate.error.network': 'Network error occurred',
    'activate.error.invalid_link': 'Invalid Activation Link',
    'activate.error.invalid_link_description': 'The activation link you clicked is invalid or has expired. Please try registering again or contact support.',
};
